module.exports = __webpack_public_path__ + "static/media/mock-logo-180x180.7b5ffc6c.png";